import { SagaIterator } from 'redux-saga'
import { IAlertState } from '../components/alert/store/alert.types'
import { areObjectsEqual, compareObjectsIfEqual, filterOutObjectKeys } from './object.util'
import { physicianDetailsInit } from '../features/patientDemographics/store/patientDemographics.reducer'
import {
  IPatientDemographicsState,
  IPhysicianDetail,
} from '../features/patientDemographics/store/patientDemographics.types'
import { Dispatch } from 'react'
import { TFunction } from 'react-i18next'
import { showAlert } from '../components/alert/store/alert.actions'
import {
  IRelationshipsAndGuarantors,
  IRelationshipsAndGuarantorsList,
} from '../features/relationshipsAndGuarantors/store/relationshipsAndGuarantors.types'
import { initialRelationshipsAndGuarantors } from '../features/relationshipsAndGuarantors/store/relationshipsAndGuarantors.reducers'
import {
  IInsuranceInformation,
  IInsuranceInformationList,
} from '../features/insuranceInformation/store/insuranceInformation.types'
import { initialInsuranceInformation } from '../features/insuranceInformation/store/insuranceInformation.reducers'

export const hasUnsavedPhysiciansData = (patientDemographics: IPatientDemographicsState) => {
  if (!patientDemographics) {
    return false
  }
  const { physicianData, physicianDataList } = patientDemographics
  const physData: IPhysicianDetail | undefined = physicianDataList.find((pData) => pData.key === physicianData.key)
  if (physData) {
    const areEqual = areObjectsEqual(physData, physicianData)
    return !areEqual
  } else {
    const fieldsToFilter = ['key']
    const currentState = filterOutObjectKeys(physicianData, fieldsToFilter)
    const initalState = filterOutObjectKeys(physicianDetailsInit, fieldsToFilter)
    return !compareObjectsIfEqual(initalState, currentState)
  }
}

export const hasUnsavedRandGData = (
  relationshipsAndGuarantorsData: IRelationshipsAndGuarantors,
  relationshipsAndGuarantorsList: IRelationshipsAndGuarantorsList
) => {
  const rAndgdata: IRelationshipsAndGuarantors | undefined = relationshipsAndGuarantorsList.find(
    (rAndgdata) => rAndgdata.key === relationshipsAndGuarantorsData.key
  )
  if (rAndgdata) {
    const areEqual = areObjectsEqual(rAndgdata, relationshipsAndGuarantorsData)
    return !areEqual
  } else {
    const fieldsToFilter = ['key']
    const currentState = filterOutObjectKeys(relationshipsAndGuarantorsData, fieldsToFilter)
    const initalState = filterOutObjectKeys(initialRelationshipsAndGuarantors, fieldsToFilter)
    return !compareObjectsIfEqual(initalState, currentState)
  }
}

export const hasUnsavedInsuranceData = (
  insuranceInformationData: IInsuranceInformation,
  insuranceInformationList: IInsuranceInformationList
) => {
  const iInfo: IInsuranceInformation | undefined = insuranceInformationList.find(
    (insuranceInfo) => insuranceInfo.key === insuranceInformationData.key
  )
  if (iInfo) {
    const areEqual = areObjectsEqual(iInfo, insuranceInformationData)
    return !areEqual
  } else {
    const fieldsToFilter = ['key, ptid', 'ageUnit']
    const currentState = filterOutObjectKeys(insuranceInformationData, fieldsToFilter)
    const initalState = filterOutObjectKeys(initialInsuranceInformation, fieldsToFilter)
    return !compareObjectsIfEqual(initalState, currentState)
  }
}

export const showUnsavedDataWarningMessage = (
  dispatch: Dispatch<SagaIterator>,
  t: TFunction<'translation'>,
  message: string,
  onBackClickYes: () => void
) => {
  const unSavedDataWarning: IAlertState = {
    header: t('common.unsavedDataWarningHeader'),
    message,
    buttons: [
      { text: 'No' },
      {
        text: 'Yes',
        handler: () => {
          onBackClickYes()
        },
      },
    ],
  }
  dispatch(showAlert(unSavedDataWarning))
}
